import { render, staticRenderFns } from "./RecommendedBenefitLevel.vue?vue&type=template&id=08ac3999&scoped=true"
import script from "./RecommendedBenefitLevel.vue?vue&type=script&lang=js"
export * from "./RecommendedBenefitLevel.vue?vue&type=script&lang=js"
import style0 from "./RecommendedBenefitLevel.vue?vue&type=style&index=0&id=08ac3999&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ac3999",
  null
  
)

export default component.exports